import React, {useState, useEffect, useContext} from 'react';
import { 
  Container, 
  Grid, 
  makeStyles 
} from '@material-ui/core';
import Page from 'src/components/Page';
import {getVoiceover} from './helperFx';
import Recorder from './Recorder';
import MyRecordings from './MyRecordings';
import MusicianContext from 'src/musicianContext';

const INTENTS = [
  "welcome.speech.mp3",
  "help.global.speech.mp3",
  "end.speech.mp3",
  "unhandled.global.speech.mp3",
  "play.song.intro.mp3",
  "where.can.i.find.your.music.prompt.mp3",
  "connect.prompt.mp3",
  "where.are.you.from.speech.mp3",
];

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const VoiceoverView = () => {
  const classes = useStyles();
  const musician = useContext(MusicianContext);
  const [voiceFiles, setVoiceFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentRecording, setCurrentRecording] = useState();
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    const fetchFirebaseMusic = async () => {
        await updateMusicView();
        setIsLoading(false);
    }
    if (musician.musician && !voiceFiles.length) {
        fetchFirebaseMusic()
    }// eslint-disable-next-line
  }, [musician.musician, voiceFiles]);

  const updateMusicView = async () => {
    const res = await getVoiceover(musician.musician);
    updateMissingVoiceFile(res);
    setVoiceFiles(res)
  };

  const updateMissingVoiceFile = (voiceFiles) => {

    // 1. Create Array of Name attribute from each object.
    const voiceArray = [];
    for (let i = 0; i < voiceFiles.length; i++) {
      voiceArray.push(voiceFiles[i].name.substring(0, voiceFiles[i].name.indexOf("_alexa")) + ".mp3")
    }

    // 2. Find Missing Recording.
    const missingRecordingsArray = [];
    for (let i = 0; i < INTENTS.length; i++) {
      if (!voiceArray.includes(INTENTS[i])) {
        missingRecordingsArray.push(INTENTS[i])
      }
    }

    // 3. Set Current Recording.
    setCurrentRecording(missingRecordingsArray[0])
  };

  const handleRecordingChange = (value) => {
    setCurrentRecording(value);
    setPopupOpen(true);
  };

  return (
    <Page className={classes.root} title="Account">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MyRecordings 
              voiceFiles={voiceFiles}
              intents={INTENTS}
              isLoading={isLoading}
              setCurrentRecording={handleRecordingChange}
            />
          </Grid>
        </Grid>
        <Recorder 
          intent={currentRecording}
          updateMusicView={updateMusicView}
          open={popupOpen}
          setOpen={setPopupOpen}
          />
      </Container>
    </Page>
  );
};

export default VoiceoverView;
